export default function CookieBannerMount() {
  return null;
}
